// src/JoinUs.js

import React, { useState } from 'react';
import { db, addDoc, collection } from './firebase';
import useDocumentMeta from './useDocumentMeta';
import './JoinUs.css';

const JoinUs = () => {
  // ─────────────────────────────────────────────────────────
  // SEO Metadata for Join Us page
  useDocumentMeta({
    title: 'Join Us — Glass City Gladiators',
    description: 'Ready to become a Gladiator? Fill out our sign‑up form to join the Glass City Gladiators travel hockey family and start your journey today!',
    canonical: 'https://gcghockey.com/join-us',
    ogImage:   'https://gcghockey.com/assets/og-joinus.png',
    ogType:    'website'
  });
  // ─────────────────────────────────────────────────────────

  const [parentName, setParentName]         = useState('');
  const [parentEmail, setParentEmail]       = useState('');
  const [parentPhone, setParentPhone]       = useState('');
  const [childName, setChildName]           = useState('');
  const [childBirthYear, setChildBirthYear] = useState('');
  const [childPosition, setChildPosition]   = useState('');
  const [yearsPlaying, setYearsPlaying]     = useState('0');
  const [lastProgram, setLastProgram]       = useState('');
  const [interest, setInterest]             = useState('');
  const [referralSource, setReferralSource] = useState('');
  const [otherSource, setOtherSource]       = useState('');
  const [isSubmitted, setIsSubmitted]       = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const source = referralSource === 'Other' ? otherSource : referralSource;

    const formData = {
      parentName,
      parentEmail,
      parentPhone,
      childName,
      childBirthYear,
      childPosition,
      yearsPlaying,
      lastProgram,
      interest,
      heardFrom: source,
      submittedAt: new Date().toISOString(),
    };

    try {
      const submissionsRef = collection(db, 'submissions');
      const docRef = await addDoc(submissionsRef, formData);
      console.log('Document written with ID:', docRef.id);
      setIsSubmitted(true);
    } catch (err) {
      console.error('Error adding document:', err);
    }
  };

  if (isSubmitted) {
    return (
      <div className="join-us-page">
        <h1>Thank You!</h1>
        <p>We appreciate your commitment to your skater's future and look forward to speaking with you soon.</p>
      </div>
    );
  }

  return (
    <div className="join-us-page">
      <h1 className="join-us-heading">Do you have what it takes to become a Gladiator?</h1>
      <p className="join-us-subheading">Fill out the form below.</p>

      <form className="join-us-form" onSubmit={handleSubmit}>
        {/* Parent Info */}
        <div className="form-group">
          <label>Parent's Name</label>
          <input
            type="text"
            value={parentName}
            onChange={e => setParentName(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label>Parent's Email</label>
          <input
            type="email"
            value={parentEmail}
            onChange={e => setParentEmail(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label>Parent's Phone</label>
          <input
            type="tel"
            value={parentPhone}
            onChange={e => setParentPhone(e.target.value)}
            required
          />
        </div>

        {/* Child Info */}
        <div className="form-group">
          <label>Child's Name</label>
          <input
            type="text"
            value={childName}
            onChange={e => setChildName(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label>Child's Birth Year</label>
          <input
            type="number"
            value={childBirthYear}
            onChange={e => setChildBirthYear(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label>Child's Playing Position</label>
          <select
            value={childPosition}
            onChange={e => setChildPosition(e.target.value)}
            required
          >
            <option value="">-- Select --</option>
            <option value="Forward">Forward</option>
            <option value="Defense">Defense</option>
            <option value="Goalie">Goalie</option>
          </select>
        </div>

        {/* Experience */}
        <div className="form-group">
          <label>Years Playing Travel Hockey</label>
          <select
            value={yearsPlaying}
            onChange={e => setYearsPlaying(e.target.value)}
            required
          >
            <option value="0">0</option>
            <option value="1">1</option>
            <option value="2-3">2-3</option>
            <option value="3+">3+</option>
          </select>
        </div>
        {yearsPlaying !== '0' && (
          <div className="form-group">
            <label>Which Travel Program Did They Last Play For?</label>
            <input
              type="text"
              value={lastProgram}
              onChange={e => setLastProgram(e.target.value)}
              required
            />
          </div>
        )}

        {/* Interest */}
        <div className="form-group">
          <label>Why are you interested in the Gladiator Program?</label>
          <textarea
            value={interest}
            onChange={e => setInterest(e.target.value)}
            required
          />
        </div>

        {/* Referral Source Dropdown */}
        <div className="form-group referral-group">
          <label>How did you hear about us?</label>
          <select
            value={referralSource}
            onChange={e => setReferralSource(e.target.value)}
            required
          >
            <option value="">-- Select One --</option>
            <option value="Social Media">Social Media</option>
            <option value="Flyer">Flyer</option>
            <option value="Online Search">Online Search</option>
            <option value="Website">Website</option>
            <option value="Friend">Friend</option>
            <option value="Word of Mouth">Word of Mouth</option>
            <option value="Other">Other</option>
          </select>
          {referralSource === 'Other' && (
            <div className="other-source">
              <label>Please specify</label>
              <input
                type="text"
                value={otherSource}
                onChange={e => setOtherSource(e.target.value)}
                required
              />
            </div>
          )}
        </div>

        <button className="submit-button" type="submit">
          Submit
        </button>
      </form>
    </div>
  );
};

export default JoinUs;
